var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{attrs:{"perPage":1,"autoplay":true,"autoplayTimeout":2000,"paginationEnabled":false,"loop":true}},_vm._l((_vm.banners),function(banner,index){return _c('slide',{key:index},[_c('div',{class:{ 'bg-image': _vm.bgImg },style:({ 
        'background': 'url('+banner.url+')',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
        'background-attachment': 'inherit'
      })})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f48705e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = null
// module chunks = 